function normalizeLungFollowupRecord(row = {}) {
  return {
    ...row,
    displayFollowupTime: row.followupTime || null,
    displayStatus: row.status || (row.followupFlag ? '已电话通知' : '未电话通知'),
    displayFollowupType: row.serviceName || '-',
    displayReviewItem: row.reviewItem || '-',
    displayReviewExpireTime: row.reviewExpireTime || null
  };
}

function isLungFollowupRecord(row = {}) {
  return row.serviceName === '肺结节随访';
}

module.exports = {
  normalizeLungFollowupRecord,
  isLungFollowupRecord
};
